// GrowthLoopSeed.js

export const DOMAINS = [
  {
    id: "screen",
    title: {
      en: "Screen-Induced Attention Fragmentation",
      hi: "स्क्रीन-प्रेरित ध्यान में विखंडन"
    },
    questions: {
      parent: {
        en: [
          "Struggles to focus after screen use",
          "Prefers fast digital content over slow activities",
          "Finds it hard to return to tasks after screen time",
          "Becomes restless without digital stimulation"
        ],
        hi: [
          "स्क्रीन उपयोग के बाद ध्यान केंद्रित करने में कठिनाई",
          "धीरे गतिविधियों की बजाय तेज़ डिजिटल सामग्री पसंद करता है",
          "स्क्रीन समय के बाद कार्य पर लौटना मुश्किल लगता है",
          "डिजिटल उत्तेजना के बिना बेचैन हो जाता है"
        ]
      },
      educator: {
        en: [
          "Appears more distracted after screen-heavy days",
          "Transitions poorly into structured activities"
        ],
        hi: [
          "स्क्रीन-भरे दिनों के बाद अधिक विचलित दिखता है",
          "संरचित गतिविधियों में खराब संक्रमण"
        ]
      },
      doctor: {
        en: ["Screen exposure appears to exacerbate attention difficulties"],
        hi: ["स्क्रीन संपर्क से ध्यान की कठिनाइयाँ बढ़ती दिखती हैं"]
      },
    observer: {
      en: [
        "Seems distracted or restless during community/group activities after screen-heavy days",
        "Struggles to stay engaged in outdoor or offline group settings"
      ],
      hi: [
        "स्क्रीन-भरे दिनों के बाद सामुदायिक/समूह गतिविधियों में विचलित या बेचैन दिखता है",
        "बाहरी या ऑफ़लाइन समूह की स्थितियों में जुड़े रहने में कठिनाई"
      ]
    }
    }
  },
  {
    id: "executive",
    title: {
      en: "Executive Function & Task Completion",
      hi: "कार्यकारी कार्य और कार्य पूरा करना"
    },
    questions: {
      parent: {
        en: [
          "Needs repeated reminders to start tasks",
          "Leaves tasks unfinished",
          "Struggles with multi-step instructions"
        ],
        hi: [
          "कार्य शुरू करने के लिए बार-बार याद दिलाने की आवश्यकता",
          "कार्य अधूरा छोड़ देता है",
          "कई-स्टेप निर्देशों का पालन करने में कठिनाई"
        ]
      },
      educator: {
        en: ["Requires frequent prompts to begin work"],
        hi: ["कार्य शुरू करने के लिए अक्सर संकेत की आवश्यकता होती है"]
      },
      doctor: {
        en: ["Difficulty initiating age-appropriate tasks"],
        hi: ["आयु-उपयुक्त कार्य शुरू करने में कठिनाई"]
      },
    observer: {
      en: [
        "Needs extra prompting to follow through on community tasks or errands",
        "Loses track of simple instructions given outside home or school"
      ],
      hi: [
        "सामुदायिक कार्यों या काम को पूरा करने के लिए अतिरिक्त संकेत की आवश्यकता",
        "घर या स्कूल के बाहर दिए गए सरल निर्देशों को भूल जाता है"
      ]
    }
    }
  },
  {
    id: "emotional",
    title: { en: "Emotional Regulation & Resilience", hi: "भावनात्मक नियंत्रण और लचीलापन" },
    questions: {
      parent: {
        en: ["Overreacts to small frustrations", "Takes long to calm down"],
        hi: ["छोटी निराशाओं पर अधिक प्रतिक्रिया करता है", "शांत होने में समय लगता है"]
      },
      educator: {
        en: ["Needs adult support to regulate emotions"],
        hi: ["भावनाओं को नियंत्रित करने के लिए वयस्क सहायता की आवश्यकता"]
      },
      doctor: {
        en: ["Emotional responses are intense or prolonged"],
        hi: ["भावनात्मक प्रतिक्रियाएँ तीव्र या लंबे समय तक होती हैं"]
      },
    observer: {
      en: [
        "Reacts strongly to minor setbacks in group or social settings",
        "Takes noticeably longer than peers to settle after an upset"
      ],
      hi: [
        "समूह या सामाजिक स्थितियों में छोटी बाधाओं पर तीव्र प्रतिक्रिया",
        "परेशान होने के बाद साथियों की तुलना में शांत होने में अधिक समय"
      ]
    }
    }
  },
  {
    id: "esteem",
    title: { en: "Self-Esteem & Motivation", hi: "आत्म-सम्मान और प्रेरणा" },
    questions: {
      parent: {
        en: ["Gives up quickly when tasks feel difficult", "Avoids new challenges"],
        hi: ["कार्य कठिन लगने पर जल्दी हार मानता है", "नई चुनौतियों से बचता है"]
      },
      educator: {
        en: ["Avoids participation after mistakes"],
        hi: ["गलतियों के बाद भागीदारी से बचता है"]
      },
      doctor: {
        en: ["Low confidence affects engagement"],
        hi: ["कम आत्मविश्वास जुड़ाव को प्रभावित करता है"]
      },
    observer: {
      en: [
        "Hesitates to join in community or group activities",
        "Withdraws quickly after a setback in front of others"
      ],
      hi: [
        "सामुदायिक या समूह गतिविधियों में शामिल होने में हिचकिचाहट",
        "दूसरों के सामने असफलता के बाद जल्दी पीछे हट जाता है"
      ]
    }
    }
  },
  {
    id: "learning",
    title: { en: "Learning Readiness & Routines", hi: "शिक्षा की तत्परता और दिनचर्या" },
    questions: {
      parent: {
        en: ["Struggles with routines and transitions"],
        hi: ["दिनचर्या और संक्रमण में कठिनाई"]
      },
      educator: {
        en: ["Difficulty managing materials"],
        hi: ["सामग्री प्रबंधन में कठिनाई"]
      },
      doctor: {
        en: ["Learning readiness gaps beyond academics"],
        hi: ["अकादमिक से परे सीखने की तत्परता में अंतर"]
      },
    observer: {
      en: [
        "Has difficulty adjusting to new or unfamiliar routines outside home/school",
        "Needs repeated guidance to manage simple everyday tasks"
      ],
      hi: [
        "घर/स्कूल के बाहर नई या अपरिचित दिनचर्या में समायोजन में कठिनाई",
        "सामान्य दैनिक कार्यों के प्रबंधन के लिए बार-बार मार्गदर्शन की आवश्यकता"
      ]
    }
    }
  },
  {
    id: "adhd",
    title: { en: "Attention & Impulse Regulation Indicators", hi: "ध्यान और आवेग नियंत्रण संकेतक" },
    questions: {
      parent: {
        en: ["Frequently fidgets", "Acts without thinking"],
        hi: ["अक्सर बेचैन रहता है", "सोचे बिना कार्य करता है"]
      },
      educator: {
        en: ["Interrupts peers"],
        hi: ["साथियों को बाधित करता है"]
      },
      doctor: {
        en: ["Attention and impulse difficulties across settings"],
        hi: ["विभिन्न परिस्थितियों में ध्यान और आवेग की कठिनाइयाँ"]
      },
    observer: {
      en: [
        "Appears fidgety or restless during community gatherings or group sessions",
        "Acts on impulse in unfamiliar or unstructured settings"
      ],
      hi: [
        "सामुदायिक सभाओं या समूह सत्रों के दौरान बेचैन या चंचल दिखता है",
        "अपरिचित या असंरचित स्थितियों में बिना सोचे कार्य करता है"
      ]
    }
    }
  }
];

export const DEEP_DIVE_DOMAINS = {
  screen: {
    en: [
      "What type of screen content is used most often (short videos, gaming, learning, social)?",
      "Does focus or behavior improve on low-screen or no-screen days?",
      "Is screen use mostly passive (watching) or interactive (responding, creating)?",
      "What behavior is seen immediately after screen time ends?",
      "Does advance warning before screen-off reduce difficulty?"
    ],
    hi: [
      "सबसे अधिक किस प्रकार की स्क्रीन सामग्री का उपयोग किया जाता है (संक्षिप्त वीडियो, गेमिंग, शिक्षा, सोशल)?",
      "कम-स्क्रीन या नो-स्क्रीन दिनों में ध्यान या व्यवहार में सुधार होता है?",
      "क्या स्क्रीन उपयोग मुख्यतः निष्क्रिय (देखना) या इंटरैक्टिव (प्रतिक्रिया, निर्माण) है?",
      "स्क्रीन समय समाप्त होने के तुरंत बाद क्या व्यवहार देखा जाता है?",
      "स्क्रीन बंद करने से पहले पूर्व चेतावनी कठिनाई को कम करती है?"
    ]
  },
  executive: {
    en: [
      "Which part of a task is hardest: starting, continuing, or finishing?",
      "Does breaking tasks into smaller steps reduce resistance?",
      "Is time awareness lost once the task begins?",
      "Do visual aids (checklists, timers) help more than verbal reminders?",
      "Are difficulties consistent across all tasks or only certain types?"
    ],
    hi: [
      "किस भाग में सबसे कठिनाई है: शुरू करना, जारी रखना, या पूरा करना?",
      "क्या कार्यों को छोटे चरणों में विभाजित करने से प्रतिरोध कम होता है?",
      "क्या कार्य शुरू होते ही समय की समझ खो जाती है?",
      "क्या दृश्य सहायक (चेकलिस्ट, टाइमर) मौखिक अनुस्मारक की तुलना में अधिक मदद करते हैं?",
      "क्या कठिनाइयाँ सभी कार्यों में समान हैं या केवल कुछ प्रकार के कार्यों में?"
    ]
  },
  emotional: {
    en: [
      "What situations most commonly trigger emotional escalation?",
      "How intense are emotional reactions compared to peers?",
      "How long does it usually take to return to calm?",
      "Does adult presence or reassurance shorten recovery time?",
      "Are emotions expressed more through words or behaviors?"
    ],
    hi: [
      "कौन सी परिस्थितियाँ सबसे आम तौर पर भावनात्मक वृद्धि को ट्रिगर करती हैं?",
      "साथियों की तुलना में भावनात्मक प्रतिक्रियाएँ कितनी तीव्र हैं?",
      "शांत होने में आमतौर पर कितना समय लगता है?",
      "क्या वयस्क की उपस्थिति या आश्वासन रिकवरी समय को कम करता है?",
      "भावनाओं को शब्दों या व्यवहार के माध्यम से अधिक व्यक्त किया जाता है?"
    ]
  },
  esteem: {
    en: [
      "Which types of tasks are most often avoided or resisted?",
      "Does the child give up quickly after making mistakes?",
      "How does the child respond to effort-based praise?",
      "Is self-talk more negative after failure or correction?",
      "Does small success increase willingness to try again?"
    ],
    hi: [
      "कौन से प्रकार के कार्य सबसे अधिक टाले या रोके जाते हैं?",
      "क्या बच्चा गलतियों के बाद जल्दी हार मानता है?",
      "बच्चा प्रयास-आधारित प्रशंसा पर कैसे प्रतिक्रिया करता है?",
      "क्या असफलता या सुधार के बाद आत्म-संवाद अधिक नकारात्मक होता है?",
      "क्या छोटी सफलता फिर से प्रयास करने की इच्छा बढ़ाती है?"
    ]
  },
  learning: {
    en: [
      "Which daily routines or transitions break down most often?",
      "Is difficulty higher in unstructured or open-ended settings?",
      "Does predictability or advance notice improve engagement?",
      "Are transitions harder than sustained activities?",
      "Does learning improve when instructions are visual and concrete?"
    ],
    hi: [
      "कौन सी दैनिक दिनचर्या या संक्रमण सबसे अधिक टूटते हैं?",
      "क्या असंरचित या खुले-समाप्ति सेटिंग्स में कठिनाई अधिक है?",
      "क्या पूर्वानुमान या पूर्व सूचना जुड़ाव को बढ़ाता है?",
      "क्या संक्रमण स्थायी गतिविधियों की तुलना में कठिन हैं?",
      "क्या निर्देश दृश्य और ठोस होने पर सीखने में सुधार होता है?"
    ]
  },
  adhd: {
    en: [
      "Are attention or impulse difficulties situation-specific or present everywhere?",
      "Does physical movement improve focus or calmness?",
      "Are challenges observed across home, school, and play?",
      "Do structured cues (timers, visual rules) reduce impulsivity?",
      "Are difficulties persistent despite consistent routines?"
    ],
    hi: [
      "क्या ध्यान या आवेग कठिनाइयाँ परिस्थितियों-विशिष्ट हैं या सभी जगह मौजूद हैं?",
      "क्या शारीरिक गतिविधि ध्यान या शांति में सुधार करती है?",
      "क्या चुनौतियाँ घर, स्कूल और खेल में देखी जाती हैं?",
      "क्या संरचित संकेत (टाइमर, दृश्य नियम) आवेगशीलता को कम करते हैं?",
      "क्या लगातार दिनचर्या के बावजूद कठिनाइयाँ बनी रहती हैं?"
    ]
  }
};

export const DEEP_DIVE_CTAS = {
  triggerDriven: {
    label: {
      en: "Identify & manage triggers",
      hi: "ट्रिगर्स की पहचान और प्रबंधन करें"
    },
    action: {
      en: "Open DeepThinking (RCA) for this domain",
      hi: "इस डोमेन के लिए डीपथिंकिंग (RCA) खोलें"
    }
  },
  structureResponsive: {
    label: {
      en: "Externalize structure",
      hi: "संरचना को बाहरी बनाएं"
    },
    action: {
      en: "Create a Micro-Routine in Chronicle",
      hi: "क्रॉनिकल में एक माइक्रो-रूटीन बनाएं"
    }
  },
  contextSpecific: {
    label: {
      en: "Align environments",
      hi: "परिसरों को संरेखित करें"
    },
    action: {
      en: "Request cross-stakeholder observation",
      hi: "क्रॉस-स्टेकहोल्डर निरीक्षण का अनुरोध करें"
    }
  },
  coRegulationHelpful: {
    label: {
      en: "Strengthen co-regulation",
      hi: "सह-नियमन को मजबूत करें"
    },
    action: {
      en: "Activate Parent / Teacher Applause loop",
      hi: "अभिभावक/शिक्षक प्रशंसा लूप सक्रिय करें"
    }
  }
};

export const assessmentHistory = {
  master: {
    title: "GrowthLoop – Executive & Emotional Mapping",
    childName: "Child A",
    createdAt: "12/01/2026"
  },
  accessors: [
    { name: "Parent 1", category: "Parent" },
    { name: "Ms. Sharma", category: "Educator" },
    { name: "Dr. Mehta", category: "Doctor" },
    { name: "Therapist X", category: "External" }
  ],
  accessLog: [
    {
      sn: 1,
      datetime: "12/01/2026 10:12:45",
      name: "Ms. Sharma",
      code: "T5W9A8C3X2P7Q4L1"
    },
    {
      sn: 2,
      datetime: "13/01/2026 18:42:10",
      name: "Dr. Mehta",
      code: "D8K2P9Q7M1X4Z6A"
    }
  ]
};
